import { Vue, i18n } from "Components/vue"

// import components
import Autocomplete from 'Components/vue/Autocomplete.vue';
import Minicart from 'Components/vue/Minicart.vue';

import 'Ui/toggle';
import 'Components/navigation';
import 'Common/sticky-header';

window.$_autocomplete = new Vue({
    i18n,
    render: h => h(Autocomplete)
}).$mount("#autocomplete");

window.$_minicart = new Vue({
    i18n,
    render: h => h(Minicart)
}).$mount("#minicart");

document.querySelector('.js-trigger-search').addEventListener('click', event => {
    event.preventDefault();

    rEvent.dispatch("Autocomplete.showForm");
});
